import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ICardNetTyp_PinTrialLimFormMeta {
    cardNetworkType: FormInputMeta;
    pinTrialLimit: FormInputMeta;
}
const cardNetTyp_PinTrialLimFormMeta = {} as ICardNetTyp_PinTrialLimFormMeta;

cardNetTyp_PinTrialLimFormMeta.cardNetworkType = {
    name: "cardNetworkType",
    type: "text",
    label: "Type Réseau carte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

cardNetTyp_PinTrialLimFormMeta.pinTrialLimit = {
    name: "pinTrialLimit",
    type: "number",
    label: "Limite Essai PIN",
    placeholder: "",
    validation: yup.number().min(1, "Nombre de tentative minimale : 1").required("Champ obligatoire !")
};

export default cardNetTyp_PinTrialLimFormMeta;